//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.ShipDesign.SelectPartBuilder.js";
import "../no/Features.js";
let d=[[[0,"SectionMappingFile",1,0],[1,"SelectPart",0,"Features.ShipDesign.SelectPartBuilder",0],[0,"TransitionMethod",1,0],[0,"TransitionType",1,0]],[[["sectionParts"],"SetSectionBlockParts",{},1,0],[["framePartFilenames"],"SetFrameParts",{},1,0],[[],"DryRun",{},0,0]],[]];
SPLM.Features.ShipDesign.TransitionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.TransitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.TransitionBuilder.TransitionTypes = Object.freeze({
    "Section" : "Section", "Frame" : "Frame"});

SPLM.Features.ShipDesign.TransitionBuilder.TransitionMethods = Object.freeze({
    "UpdateExisting" : "UpdateExisting", "CreateNew" : "CreateNew"});

export default SPLM;